class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    console.log(event.target.dataset.index);
    console.log(event.target.value);
    console.log(document.activeElement.getAttribute('name'));
    if (event.target.dataset.change == 'variant') {
      this.updateVariant(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
      return;
    }
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'main-cart-sidebar',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.sidebar-js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      }
    ];
  }

  addProduct(id, quantity) {
    const body = JSON.stringify({
      id,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }})
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);
      this.classList.toggle('is-empty', parsedState.item_count === 0);
      const cartFooter = document.getElementById('main-cart-footer');
      const cartItems = document.getElementById('main-cart-items');

      if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

      this.getSectionsToRender().forEach((section => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        
          elementToReplace.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        
      }));
      //cartItems.scrollIntoView();
      const lineItem = document.querySelector(`.cart-item[data-id="${id}"]`);
      if (lineItem ) lineItem.focus();


      this.disableLoading();
    }).catch((e) => {
      console.log(e);
      this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
      document.getElementById('cart-errors').textContent = window.cartStrings.error;
      this.disableLoading();
    });
  }

  updateMasterId(line) {
    this.currentVariant = this.getVariantData(line).find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  getVariantData(line) {
    this.variantData = this.variantData || JSON.parse(this.querySelector(`#CartItem-${line} [type="application/json"]`).textContent);
    return this.variantData;
  }

  updateOptions(line) {
    console.log(line);
    const lineElem = this.querySelector(`#CartItem-${line}`);
    const fieldsets = Array.from(lineElem.querySelectorAll('fieldset'));
    this.options = Array.from(lineElem.querySelectorAll('select'), (select) => select.value);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if (!this.stickyHeader) return;
    this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
  }
  

  updateVariant(line, variant, name) {
    
    //this.enableLoading(line);
    const oldQuantity = this.querySelector(`#CartItem-${line} quantity-input input`).value;
    const quantity = 0;
    this.updateOptions(line);
    this.updateMasterId(line);
    console.log(this.currentVariant);

    
    this.closest('cart-items').replaceProduct(line, quantity, oldQuantity, name);

    return false;

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          
            elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

          
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        this.disableLoading();
      }).catch((e) => {
        console.log(e);
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });

  }

  replaceProduct(line, quantity, oldQuantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.closest('cart-items').addProduct(this.currentVariant.id, oldQuantity);




        this.updateLiveRegions(line, parsedState.item_count);
        this.disableLoading();

      }).catch((e) => {
        console.log(e);
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        //this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

var vatCheckbox = document.querySelector("#vat_number");
var vatExpandableField = document.querySelector('.vat-number__expand');


if (vatCheckbox && vatExpandableField) {
  var vatInput = vatExpandableField.querySelector('input');
  var vatInputError = vatExpandableField.querySelector('#vat-error');
  
  function expandVatToggle() {    
    if (vatCheckbox.checked) {
      vatExpandableField.classList.remove('hidden');
      trapFocus(vatInput);
    } else {
      vatExpandableField.classList.add('hidden');
      removeTrapFocus(vatInput);
    }
  }
  expandVatToggle(vatCheckbox);
  vatCheckbox.addEventListener('change', expandVatToggle);

  vatInput.addEventListener('keyup', checkVat);
  function checkVat(e) {
    const regExpattern = /^[A-Za-z]{2,4}(?=.{2,12}$)[-_\s0-9]*(?:[a-zA-Z][-_\s0-9]*){0,2}$/;
    console.log(vatInput.value);
    if (regExpattern.test(vatInput.value) == false) {
      vatInputError.classList.remove('hidden');

    } else {
      vatInputError.classList.add('hidden');
      vatInput.classList.remove('correct');

      if (vatInput.value.length > 10) {
        //return;
        fetch(`https://controleerbtwnummer.eu/api/validate/${vatInput.value}.json`)
        .then(response => response.json())
        .then(data => {
          if (data.valid) {
            vatInputError.classList.add('hidden');
            vatInput.classList.add('correct');
            
          } else {
            vatInputError.classList.remove('hidden');
            vatInput.classList.remove('correct');

          }
        });
      }
    }
  }


}